
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';

function AuthenticationModal({
  item,
  getProfile,
  enable2fa,
  history
}) {

  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState(item)

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnVerify = (e) => {
    e.preventDefault();

    enable2fa(formData, () => {
      setModal({ isOpen: false });
      getProfile();
      history.push('/profile');
    });
  };

  return (
    <Modal.Body>
      <div className="mfa-modal">
        <div className='col-12 title'>
          Please follow the steps to update your authentication:
        </div>
        <div className='col-12 numeric ml-1 mt-3'>
          1. Scan QR Code with authenticator app
        </div>
        <div className='col-12 ml-3 title-setupkey'>
          Open your selected authenticator app and scan the QR code.
        </div>
        <div className='mt-3 d-flex ml-2 pl-3'>
          {_.get(formData, 'data.qr_code_url') ? (
            <>
              <div className='col-5 border ml-2'>
                <img
                  alt=""
                  src={_.get(formData, 'data.qr_code_url')}
                  style={{ height: '100px', width: '100px', marginTop: '8px', marginBottom: '8px', marginLeft: '30px' }}
                  className="text-center"
                />
              </div>
              <div className='col-6 border ml-2'>
                <div>
                  <p className="text-center mt-3 pt-1 mb-2 title-setupkey">
                    You can also enter this setup key:
                  </p>
                </div>
                <div>
                  <p className="text-center mt-0 cms-text-primary font-weight-bold">{`${_.get(formData, "data.google2fa_secret")}`}</p>
                </div>
              </div>
            </>
          ) : (
            <div className="border text-center p-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
                style={{ height: '150px', width: '150px', top: '-5px' }}
              />
            </div>
          )}
        </div>
        <div className='col-12 numeric ml-1 mt-3'>
          2. Enter verification code
        </div>
        <div className='col-12 ml-3 title-setupkey'>
          Your authenticator app will generate a verification code. Enter this code below:
        </div>
        <div className="input-group mb-3 col-10 mt-2 ml-3">
          <InputMask
            placeholder='Enter confirmation code'
            className='form-control'
            maskChar=' '
            mask='999999'
            autoComplete='none'
            id='secret'
            name='secret'
            onChange={handleOnChange}
            value={_.get(formData, "secret") || ""}
          />
          <div className="input-group-append">
            <button
              type="button"
              disabled={_.isEmpty(_.get(formData, "secret"))}
              className="btn btn-submit"
              onClick={handleOnVerify}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

AuthenticationModal.defaultProps = {
  item: {},
};

AuthenticationModal.propTypes = {
  item: PropTypes.instanceOf(Object),
  enable2fa: PropTypes.instanceOf(Function).isRequired,
  getProfile: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(AuthenticationModal);